import type { Vendor, Category } from '../../../../types';
import { useEscClose } from '../../../../lib/a11y/useEscClose';
import { Scrollable } from '../../../../components/primitives/Scrollable';
import { VendorHero } from './VendorHero';
import { VendorDetailIdentity } from './VendorDetailIdentity';
import { VendorCategoryStrip } from './VendorCategoryStrip';
import { StageSchedule } from '../../../schedule/components/StageSchedule';
import shared from './shared.module.css';
import styles from './Desktop.module.css';

interface Props {
  vendor: Vendor;
  category?: Category | undefined;
  locationName?: string | undefined;
  onBack: () => void;
}

export function Desktop({ vendor, category, locationName, onBack }: Props) {
  useEscClose(true, onBack);

  const story = vendor.description;

  return (
    <div className={styles.panel} data-testid="vendor-detail">
      <VendorCategoryStrip vendor={vendor} category={category} onClose={onBack} />
      <VendorHero key={vendor.uid} vendor={vendor} category={category} />
      <VendorDetailIdentity vendor={vendor} locationName={locationName} />
      <Scrollable className={styles.body}>
        <div className={styles.bodyInner}>
          {story && <p className={shared.descriptionBlock}>{story}</p>}
          {vendor.type === 'stage' && locationName && (
            <StageSchedule stageLocation={locationName} />
          )}
        </div>
      </Scrollable>
    </div>
  );
}
